import { t } from '@lingui/core/macro';
import { CircularProgress, Flexbox, TertiaryIconButton } from '@luminovo/design-system';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';

export interface UpDownButtonsProps {
    isLoading: boolean;
    isDisabledFirstRow: boolean;
    isDisabledLastRow: boolean;
    onClickUp: () => void;
    onClickDown: () => void;
}

export const UpDownButtons = ({
    isLoading,
    isDisabledFirstRow,
    isDisabledLastRow,
    onClickUp,
    onClickDown,
}: UpDownButtonsProps): JSX.Element => {
    return (
        <Flexbox
            sx={{
                flexDirection: 'row',
                alignContent: 'center',
                justifyContent: 'center',
            }}
        >
            {isLoading && <CircularProgress size="small" />}
            {!isLoading && (
                <>
                    <TertiaryIconButton
                        aria-label={t`Move up`}
                        disabled={isDisabledFirstRow}
                        size="medium"
                        onClick={onClickUp}
                    >
                        <ChevronUpIcon />
                    </TertiaryIconButton>
                    <TertiaryIconButton
                        aria-label={t`Move down`}
                        disabled={isDisabledLastRow}
                        size="medium"
                        onClick={onClickDown}
                    >
                        <ChevronDownIcon />
                    </TertiaryIconButton>
                </>
            )}
        </Flexbox>
    );
};
